import { ValidationRule } from "@/types/ValidationRule"
import postcode from "@/validators/postcode"
import email from "@/validators/email"
import required from "@/validators/required"
import accountNumber from "@/validators/accountNumber"
import phoneNumber from "@/validators/phoneNumber"
import meterReading from "@/validators/meterReading"
import stringInteger from "@/validators/stringInteger"
import referralCode from "@/validators/referralCode"
import sortCode from "@/validators/sortCode"
import isTruthy from "@/validators/isTruthy"
import positiveNumber from "@/validators/positiveNumber"
import unitInterval from "@/validators/unitInterval"
import currency from "@/validators/currency"
import cardPaymentAmount from "@/validators/cardPaymentAmount"
import greaterThanZero from "./greaterThanZero"
import nameRule from "@/validators/nameRule"
import mpxn from "@/validators/mpxn"

export interface Rules {
  [key: string]: ValidationRule
}

const rules: Rules = {
  postcode,
  email,
  required,
  sortCode,
  accountNumber,
  phoneNumber,
  meterReading,
  stringInteger,
  referralCode,
  isTruthy,
  positiveNumber,
  unitInterval,
  currency,
  cardPaymentAmount,
  greaterThanZero,
  nameRule,
  mpxn,
}

export default rules
